<!-- File Input - Always rendered so ViewChild can access it -->
<input
  #fileInput
  type="file"
  accept=".png,.jpg,.jpeg,.webp,.bmp"
  class="tw-hidden"
  (change)="onFileChange($event)"
/>

@if (showUnifiedBannerLoading()) {
<div
  class="tw-w-full tw-rounded-xl tw-border tw-border-gray-200 dark:tw-border-gray-600 tw-aspect-[12/5] tw-flex tw-items-center tw-justify-center tw-bg-gray-50 dark:tw-bg-gray-800"
  [ngClass]="{'tw-rounded-b-none tw-border-b-0': timelineLayout()}"
  aria-busy="true"
>
  <progress-circle [isInfinite]="true" colorClasses="tw-border-blue-500 tw-border-r-gray-300"></progress-circle>
</div>
} @else if (hasFile()) {
<!-- Mobile View: Clickable Banner (visible on mobile, hidden on desktop) -->
<div class="lg:tw-hidden">
  <div 
    [class.tw-cursor-pointer]="!readonly()"
    (click)="openActionsModal()"
    class="tw-w-full tw-relative tw-rounded-xl tw-overflow-hidden tw-border tw-border-gray-200 banner-container"
    [ngClass]="{'tw-rounded-b-none': timelineLayout(), 'tw-aspect-[12/5]': !skipCrop()}"
  >
    @if (!skipCrop()) {
    <div
      [style.background-image]="'url(' + getDisplayBannerLqipUrl() + ')'"
      class="tw-w-full tw-h-full tw-absolute tw-top-0 tw-left-0 tw-bg-center tw-blur"
      aria-hidden="true"
    ></div>
    }
    <img
      [src]="getDisplayBannerLqipUrl()"
      [alt]="label()"
      loading="lazy"
      decoding="async"
      (load)="onBannerImageLoad($event)"
      class="tw-w-full tw-h-full tw-object-contain tw-absolute tw-top-0 tw-left-0 tw-z-10"
      [ngClass]="{'!tw-relative !tw-h-auto tw-block': skipCrop()}"
    />
  </div>
</div>

<!-- Desktop View: Hover Overlay (hidden on mobile, visible on desktop) -->
@if (showDesktopBannerOverlay()) {
<div
  [class.tw-cursor-pointer]="!readonly()"
  class="banner-container tw-border-b tw-hidden lg:tw-block tw-w-full tw-relative tw-overflow-hidden tw-rounded-xl tw-border tw-border-gray-200"
  [ngClass]="{'tw-rounded-b-none': timelineLayout(), 'tw-aspect-[12/5]': !skipCrop()}"
>
  @if (!skipCrop()) {
  <div
    [style.background-image]="'url(' + getDisplayBannerLqipUrl() + ')'"
    class="tw-w-full tw-h-full tw-absolute tw-top-0 tw-left-0 tw-bg-center tw-blur"
    aria-hidden="true"
  ></div>
  }
  <img
    [src]="getDisplayBannerLqipUrl()"
    [alt]="label()"
    loading="lazy"
    decoding="async"
    (load)="onBannerImageLoad($event)"
    class="tw-pointer-events-none tw-h-full tw-w-full tw-object-contain tw-absolute tw-top-0 tw-left-0 tw-z-10"
    [ngClass]="{'!tw-relative !tw-h-auto tw-block': skipCrop()}"
  />
  @if (!readonly()) {
  <div
    class="banner-overlay tw-absolute tw-inset-0 tw-z-10 tw-flex tw-items-center tw-justify-center tw-gap-3 tw-bg-gray-900/50 tw-opacity-0 tw-invisible tw-transition-all tw-duration-300 tw-ease-in-out group-hover:tw-opacity-100 group-hover:tw-visible hover:tw-opacity-100 hover:tw-visible"
  >
    <button
      (click)="changeBanner(); $event.stopPropagation()"
      type="button"
      class="tw-flex tw-h-10 tw-w-10 tw-cursor-pointer tw-items-center tw-justify-center tw-rounded-full tw-bg-gray-100/60 tw-border-0 tw-p-0"
      ngxTippy="Change"
    >
      <span [innerHTML]="changeIcon | safe" class="icon tw-inline-flex tw-shrink-0 tw-items-center tw-justify-center"></span>
    </button>
    @if (!skipCrop()) {
    <button
      (click)="openCropModal(); $event.stopPropagation()"
      type="button"
      class="tw-flex tw-h-10 tw-w-10 tw-cursor-pointer tw-items-center tw-justify-center tw-rounded-full tw-bg-gray-100/60 tw-border-0 tw-p-0"
      ngxTippy="Crop"
    >
      <span [innerHTML]="cropIcon | safe" class="icon tw-inline-flex tw-shrink-0 tw-items-center tw-justify-center"></span>
    </button>
    }
    <button
      (click)="deleteFile(); $event.stopPropagation()"
      type="button"
      class="tw-flex tw-h-10 tw-w-10 tw-cursor-pointer tw-items-center tw-justify-center tw-rounded-full tw-bg-red-50/60 tw-border-0 tw-p-0"
      ngxTippy="Delete"
    >
      <span [innerHTML]="deleteIcon | safe" class="removeIcon tw-inline-flex tw-shrink-0 tw-items-center tw-justify-center"></span>
    </button>
  </div>
  }
</div>
}
} @else if (isTimelineEmptyUpload()) {
  <div class="tw-flex tw-w-full tw-relative">
    <div
      (click)="openFilePicker()"
      (pointerdown)="onUploadFieldPressStart()"
      (pointerup)="onUploadFieldPressEnd()"
      (pointercancel)="onUploadFieldPressEnd()"
      (focus)="onUploadFieldPressStart()"
      (blur)="onUploadFieldPressEnd()"
      (drop)="onFileChange($event)"
      (dragover)="fileDragOver($event)"
      (dragleave)="fileDragLeave($event)"
      class="tw-flex tw-aspect-[12/5] tw-w-full tw-flex-col tw-items-center tw-justify-center tw-gap-2 tw-rounded-t-xl tw-border-0 tw-border-b lg:tw-border tw-border-dashed tw-border-gray-200 tw-bg-gray-300 lg:tw-bg-gray-100 active:tw-bg-blue-100 focus:tw-bg-blue-100 focus-visible:tw-bg-blue-100 tw-px-4 tw-py-5 tw-transition-colors tw-outline-none focus-visible:tw-ring-2 focus-visible:tw-ring-blue-500 focus-visible:tw-ring-offset-2 tw-h-full"
      [class.tw-cursor-pointer]="!readonly()"
      [ngClass]="[
        isFileDraggedOver() || isUploadFieldPressed()
          ? 'tw-bg-blue-100 lg:hover:tw-bg-blue-100'
          : showErrorState()
            ? 'tw-bg-red-50'
            : warningMessage()
              ? 'tw-bg-orange-50'
              : 'tw-bg-gray-200 lg:hover:tw-bg-gray-200'
      ]"
      tabindex="0"
    >
      @if (showIcon()) {
        <div
          class="tw-flex tw-h-11 tw-w-11 tw-shrink-0 tw-items-center tw-justify-center tw-rounded-full tw-bg-white tw-shadow-sm"
          aria-hidden="true"
        >
        <svg width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M0 2.25C0 1.01953 0.984375 0 2.25 0H15.75C16.9805 0 18 1.01953 18 2.25V13.5C18 14.7656 16.9805 15.75 15.75 15.75H2.25C0.984375 15.75 0 14.7656 0 13.5V2.25ZM11.3555 6.01172C11.2148 5.76562 10.9336 5.625 10.6875 5.625C10.4062 5.625 10.125 5.76562 9.98438 6.01172L6.92578 10.5117L5.97656 9.31641C5.83594 9.14062 5.58984 9 5.34375 9C5.0625 9 4.81641 9.14062 4.67578 9.31641L2.42578 12.1289C2.21484 12.4102 2.17969 12.7617 2.32031 13.043C2.46094 13.3242 2.74219 13.5 3.09375 13.5H6.46875H7.59375H14.9062C15.1875 13.5 15.5039 13.3594 15.6445 13.0781C15.7852 12.7969 15.75 12.4453 15.5742 12.1992L11.3555 6.01172ZM3.9375 5.625C4.85156 5.625 5.625 4.88672 5.625 3.9375C5.625 3.02344 4.85156 2.25 3.9375 2.25C2.98828 2.25 2.25 3.02344 2.25 3.9375C2.25 4.88672 2.98828 5.625 3.9375 5.625Z" fill="#1C64F2"/>
          </svg>          
        </div>
      }
      <span
        class="tw-text-center lg:tw-text-base tw-text-sm tw-font-semibold tw-leading-snug tw-text-gray-700 tw-font-inter"
      >
        {{ label() }}
        @if (isRequired()) {
          <span class="tw-text-red-500">*</span>
        }
      </span>
      @if (timelineLayout()) {
        <span
          class="tw-hidden tw-w-full tw-text-center tw-text-xs tw-font-inter tw-text-gray-500 lg:tw-block"
        >
          Click to upload or drag &amp; drop
        </span>
    } @else {
      <span class="tw-w-full tw-text-gray-500 tw-text-xs tw-text-center tw-font-inter">
        <span class="tw-text-blue-600 tw-font-bold">Click to upload</span>
        or drag & drop
      </span>
    }
      @if (bannerProblemMessage()) {
        <span
          class="tw-max-w-full tw-px-2 tw-text-center tw-text-xs tw-font-inter"
          [ngClass]="showErrorState() || warningMessage() ? 'tw-text-red-600' : 'tw-text-slate-600'"
        >
          {{ bannerProblemMessage() }}
        </span>
      }
      @if (hint()) {
        <span
          class="tw-hidden tw-max-w-full tw-px-2 tw-text-center tw-text-xs tw-font-inter tw-text-gray-500 lg:tw-block"
        >
          {{ hint() }}
        </span>
      }
    </div>
  </div>
} @else {
  <div class="tw-flex tw-w-full tw-relative banner-empty">
    <div
      (click)="openFilePicker()"
      (drop)="onFileChange($event)"
      (dragover)="fileDragOver($event)"
      (dragleave)="fileDragLeave($event)"
      [class.tw-cursor-pointer]="!readonly()"
      class="tw-h-full tw-border-2 tw-p-3 tw-border-dashed tw-transition-all tw-duration-200 tw-rounded-xl tw-flex tw-justify-center tw-items-center tw-gap-1 tw-flex-col tw-w-full tw-aspect-[12/5]"
      [ngClass]="[
        isFileDraggedOver()
          ? 'tw-bg-blue-50 tw-border-blue-300 hover:tw-bg-blue-50 hover:tw-border-blue-300'
          : showErrorState()
            ? 'tw-bg-red-100 tw-border-red-600 hover:tw-bg-red-200 hover:tw-border-red-600'
            : warningMessage()
              ? 'tw-bg-orange-100 tw-hover:tw-bg-orange-100 tw-border-orange-400 tw-hover:tw-border-orange-400'
              : 'tw-bg-gray-50 tw-border-gray-300 tw-hover:tw-bg-gray-200 tw-hover:tw-border-gray-400'
      ]"
    >
    @if(showIcon()){
        <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M10 18.8346C9.448 18.8346 9 18.369 9 17.793V16.7513H11V17.793C11 18.369 10.552 18.8346 10 18.8346Z" fill="#9CA3AF" />
          <path
            d="M16.989 8.54713C16.794 4.99505 13.958 2.16797 10.5 2.16797C7.855 2.16797 5.485 3.85755 4.494 6.36068C1.974 6.6263 0 8.84922 0 11.543C0 14.4148 2.243 16.7513 5 16.7513H9V10.9326L8.707 11.2378C8.316 11.6451 7.684 11.6451 7.293 11.2378C6.902 10.8305 6.902 10.1721 7.293 9.76484L9.293 7.68151C9.684 7.27422 10.316 7.27422 10.707 7.68151L12.707 9.76484C13.098 10.1721 13.098 10.8305 12.707 11.2378C12.512 11.4409 12.256 11.543 12 11.543C11.744 11.543 11.488 11.4409 11.293 11.2378L11 10.9326V16.7513H16C18.206 16.7513 20 14.8826 20 12.5846C20 10.643 18.718 9.00651 16.989 8.54713Z"
            fill="#9CA3AF"
          />
        </svg>
      }
      <span class="tw-w-full tw-font-bold tw-text-gray-500 tw-text-sm tw-text-center tw-font-inter">
        {{ label() }}
      @if(isRequired()){
          <span class="tw-text-red-500">*</span>
        }
      </span>
      <span class="tw-w-full tw-text-center tw-text-xs tw-font-inter tw-text-gray-500" [ngClass]="{'tw-hidden': timelineLayout()}">
        <span class="tw-text-blue-600 tw-font-bold">Click to upload</span>
        or drag &amp; drop
      </span>
      @if (bannerProblemMessage()) {
        <span
          class="tw-w-full tw-text-xs tw-text-center tw-font-inter"
          [ngClass]="showErrorState() || warningMessage() ? 'tw-text-red-600' : 'tw-text-gray-500'"
        >
          {{ bannerProblemMessage() }}
        </span>
      }
      @if (hint()) {
        <span
          class="tw-w-full tw-text-xs tw-text-center tw-font-inter tw-text-gray-500" [ngClass]="{'tw-hidden': timelineLayout()}"
        >
          {{ hint() }}
        </span>
      }
    </div>
  </div>
}

@if (isModalOpened(deleteModalId)) {
<delete-modal
  message="Are you sure you want to delete this banner?"
  [id]="deleteModalId"
  (onDelete)="confirmDeleting()"
  (onCancel)="cancelDelete()"
></delete-modal>
}

<!-- Mobile Actions Modal -->
@if (isModalOpened(actionsModalId)) {
<modal 
  [id]="actionsModalId" 
  [closeButtonEnabled]="true"
  [enableBackdropClose]="true"
  [showHeaderDivider]="false"
  [showFooterDivider]="false"
  [widthClass]="'tw-w-11/12 tw-max-w-sm'"
  [heightClass]="'200'"
>
  <div class="tw-flex tw-flex-col banner-actions-modal-body" slot="body">
    <!-- Change Action -->
    <button
      (click)="onActionClicked('change')"
      type="button"
      class="banner-action-button tw-flex tw-items-center tw-gap-3 tw-w-full tw-p-3 tw-rounded-lg tw-bg-white dark:tw-bg-gray-800 hover:tw-bg-gray-50 dark:hover:tw-bg-gray-700 tw-transition-colors"
    >
      <span [innerHTML]="changeIcon | safe" class="banner-action-icon tw-inline-flex tw-shrink-0 tw-items-center tw-justify-center"></span>
      <span class="tw-text-gray-900 dark:tw-text-gray-100 tw-text-base tw-font-normal">Change</span>
    </button>
    
    <!-- Crop Action -->
    @if (!skipCrop()) {
    <button
      (click)="onActionClicked('crop')"
      type="button"
      class="banner-action-button tw-flex tw-items-center tw-gap-3 tw-w-full tw-p-3 tw-rounded-lg tw-bg-white dark:tw-bg-gray-800 hover:tw-bg-gray-50 dark:hover:tw-bg-gray-700 tw-transition-colors"
    >
      <span [innerHTML]="cropIcon | safe" class="banner-action-icon tw-inline-flex tw-shrink-0 tw-items-center tw-justify-center"></span>
      <span class="tw-text-gray-900 dark:tw-text-gray-100 tw-text-base tw-font-normal">Crop</span>
    </button>
    }
    
    <!-- Remove Action -->
    <button
      (click)="onActionClicked('delete')"
      type="button"
      class="banner-action-button banner-action-button-remove tw-flex tw-items-center tw-gap-3 tw-w-full tw-p-3 tw-rounded-lg tw-bg-white dark:tw-bg-gray-800 hover:tw-bg-red-50 dark:hover:tw-bg-red-900/20 tw-transition-colors"
    >
      <span [innerHTML]="deleteIcon | safe" class="banner-action-icon tw-inline-flex tw-shrink-0 tw-items-center tw-justify-center"></span>
      <span class="tw-text-red-500 tw-text-base tw-font-normal">Remove</span>
    </button>
  </div>
</modal>
}

<!-- Crop Modal -->
<crop-modal
  [id]="cropModalId"
  [header]="cropModalHeader()"
  [imageFile]="getCropImageSource()"
  [aspectRatio]="12/5"
  [initialCropBox]="savedCropBox()"
  (cropped)="onImageCropped($event)"
  (cancelled)="onCropCancelled()"
  (loadFailed)="onCropLoadFailed()"
></crop-modal>
